export default __webpack_public_path__ + "static/media/t_2.0e17144c.jpg";